<template>
    <div class="sequences-tab row nav-padding"
         v-loading="loading">
        <div class="d-flex flex-row flex-grow-1">
            <div class="flex-grow-1">
                <div class="p-2">
                    <b>Source</b>
                </div>
                <div class="mt-2">
                    <company-autosuggest placeholder="Search a company to copy from"
                                         v-model="copy_from_company">
                    </company-autosuggest>
                </div>
                <div class="mt-2">
                    <sequence-selector place
                                       :company_id="copy_from_company"
                                       :disabled="!copy_from_company"
                                       v-model="selected_sequence">
                    </sequence-selector>
                </div>
            </div>
            <div class="flex-grow-1">
                <div class="p-2">
                    <b>Destination</b>
                </div>
                <div class="mt-2">
                    <company-autosuggest placeholder="Search a company to copy to"
                                         :disabled="!(copy_from_company && selected_sequence)"
                                         :except="[this.copy_from_company]"
                                         v-model="copy_to_company">
                    </company-autosuggest>
                </div>
            </div>
            <div class="flex-grow-1">
                <div class="p-2">
                    <b>Action</b>
                </div>
                <div class="mt-2">
                    <el-button type="success"
                               size="small"
                               :disabled="disableCopy"
                               @click="copy">
                        Copy
                    </el-button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import CompanySelector from '../company-selector'
import CompanyAutosuggest from '../company-autosuggest'
import SequenceSelector from "../widgets/sequence-selector"

export default {
    data() {
        return {
            loading: false,
            copy_from_company: null,
            copy_to_company: null,
            selected_sequence: null
        }
    },

    components: {
        SequenceSelector,
        CompanySelector,
        CompanyAutosuggest
    },

    computed: {
        disableCopy() {
            return !(this.copy_from_company && this.copy_to_company && this.selected_sequence)
        }
    },

    methods: {
        copy() {
            this.loading = true
            axios.post('/api/admin/company/copy-sequence', {
                copy_from_company: this.copy_from_company,
                copy_to_company: this.copy_to_company,
                sequence_id: this.selected_sequence
            }).then(res => {
                this.loading = false
                this.$notify({
                    title: 'Sequence Copy',
                    message: res.data.message,
                    type: 'success',
                    showClose: true,
                })

                // Reset
                this.copy_to_company = null
                this.copy_from_company = null
                this.selected_sequence = null
            }).catch(err => {
                this.loading = false
                this.$root.handleErrors(err.response)
            })
        }
    },

    watch: {
        copy_from_company() {
            this.copy_to_company = null
            this.selected_sequence = null
        }
    }

}
</script>
